import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import LoadingArrows from '@ott/icon-loading-arrows';

import cls from 'classnames/bind';
import s from './Loading12p.scss';

const cx = cls.bind(s);

class Loading12p extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    viewBox: PropTypes.string,
    fill: PropTypes.string,
  };

  static defaultProps = {
    width: 189,
    height: 187,
    viewBox: '0 0 189 187',
    fill: '#232323',
  };

  render() {
    const { width, fill, caption, styles, transitionStartStyles, ...otherProps } = this.props;
    const arrowsW = Math.round(width * 0.4021164021);

    return (
      <div className={cx('Loading12p')}>
        <svg
          className={cx('bg')}
          {...otherProps}
          width={width}
          height={width}
          viewBox="0 0 189 189"
        >
          <g fill={`${fill}`}>
            <path
              d="M171.504,39.553 L135.035,39.553 C134.742,17.695 116.881,0 94.952,0 C73.025,0 55.164,17.695 54.871,39.553 L17.008,39.553 C7.652,39.553 0,47.206 0,56.561 L0,169.344 C0,178.698 7.652,186.352 17.008,186.352 L171.504,186.352 C180.859,186.352 188.512,178.698 188.512,169.344 L188.512,56.561 C188.512,47.206 180.859,39.553 171.504,39.553 L171.504,39.553 Z M94.952,23 C104.197,23 111.73,30.379 112.021,39.553 L77.885,39.553 C78.174,30.379 85.709,23 94.952,23 L94.952,23 Z"
              opacity="0.8"
            />
            <path d="M112.021,40.553 C112.01,40.215 111.97,39.886 111.94,39.553 L77.966,39.553 C77.936,39.886 77.896,40.215 77.885,40.553 L112.021,40.553 L112.021,40.553 Z" />
            <path d="M171.504,39.553 L135.035,39.553 C134.742,17.695 116.881,0 94.952,0 C73.025,0 55.164,17.695 54.871,39.553 L17.008,39.553 C7.652,39.553 0,47.206 0,56.561 L0,57.561 C0,48.207 7.652,40.553 17.008,40.553 L54.871,40.553 C55.164,18.695 73.025,1 94.952,1 C116.881,1 134.742,18.695 135.035,40.553 L171.504,40.553 C180.859,40.553 188.512,48.206 188.512,57.561 L188.512,56.561 C188.512,47.206 180.859,39.553 171.504,39.553 L171.504,39.553 Z" />
          </g>
        </svg>
        {caption ? <div className={cx('caption')}>{caption}</div> : null}
        <div className={cx('arrows')}>
          <LoadingArrows {...otherProps} width={arrowsW} />
        </div>
      </div>
    );
  }
}

export default Loading12p;
